import { render, staticRenderFns } from "./study2.vue?vue&type=template&id=134cbd0e&scoped=true&"
import script from "./study2.vue?vue&type=script&lang=js&"
export * from "./study2.vue?vue&type=script&lang=js&"
import style0 from "./study2.vue?vue&type=style&index=0&id=134cbd0e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134cbd0e",
  null
  
)

export default component.exports